import classNames from 'classnames'
import React, { useState } from 'react'

import './cvc-help-button.scss'
import Button from '~/components/button'
import ContentBlock from '~/components/content-block'
import Modal from '~/components/modal'
import CVCHelpUrl from '~/graphics/cvc-help.svg'
import { i18n } from '~/i18n'

export default function CvcHelpButton({ className }: { className?: string }) {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <Button
        type="icon"
        className={classNames('cvc-info', className)}
        glyph="circle-info"
        onClick={() => setShowModal(true)}
        data-testid="cvc-help-button"
      />
      {showModal && (
        <Modal
          className="cvc-info-modal"
          title={i18n.t('components.cvc_help.title')}
          onClose={() => setShowModal(false)}
          size="small"
        >
          <div>
            <ContentBlock className="keep-to-preserve-div">
              {i18n.t('components.cvc_help.heading')}
            </ContentBlock>
            <img
              src={CVCHelpUrl}
              alt={i18n.t('components.cvc_help.alt_text')}
            />
            <ContentBlock className="keep-to-preserve-div">
              {i18n.t('components.cvc_help.content')}
            </ContentBlock>
            <Button type="primary" onClick={() => setShowModal(false)}>
              {i18n.t('components.cvc_help.close_btn')}
            </Button>
          </div>
        </Modal>
      )}
    </>
  )
}
